import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte,
  BokkzAlgDataService,
  IncomeTaxEntity,
  IngehoudenDividendbelasting
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {SPINNER_TIMEOUT} from "../../gedeelde-componenten/gedeelde-componenten.component";
import { filter, Subscription } from "rxjs";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-dividendbelasting-box2',
  templateUrl: './dividendbelasting-box2.component.html',
  styleUrls: ['./dividendbelasting-box2.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class DividendbelastingBox2Component implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;

    @Input() public id!: string;
    public clientId!: string;

    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private currentAangifte = {} as Aangifte;

    private focusedElementId: string | null = null;

    public dividendInBox2 = {} as FormGroup

    get box2Dividend(): FormArray {
        return this.dividendInBox2.get('box2Dividend') as FormArray;
    }

    addRijDividendBox2(): void {
        this.box2Dividend.push(this.createDividendBox2FormGroup())
    }

    createDividendBox2FormGroup(dividend?: IngehoudenDividendbelasting): FormGroup {
        return this.fb.group<IngehoudenDividendbelasting>({
            dividendBox2: dividend?.dividendBox2 || undefined,
            dividendbelastingBox2: dividend?.dividendbelastingBox2 || undefined,
        })
    }

    verwijderRijDividendBox2(index: number): void {
        this.box2Dividend.removeAt(index);
        this.dividendInBox2.updateValueAndValidity()
        this.dividendInBox2.markAsDirty()
        this.saveForm()
    }



    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService,
                private router: Router,
                private fb: FormBuilder) {
        this.dividendInBox2 = this.fb.group({
            box2Dividend: this.fb.array<IngehoudenDividendbelasting>([]),
        });
    }

    public ngOnInit(): void {
      this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.updateForm()
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.dividendInBox2.dirty
  }

  private updateForm(): void {
        const dividendLijst = this.aangifte?.voorheffingen?.ingehoudenDividendbelasting || [];
        const formArray = this.dividendInBox2.get('box2Dividend') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > dividendLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        for (let i = 0; i < dividendLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(dividendLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createDividendBox2FormGroup(dividendLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                voorheffingen: {
                    ...this.aangifte.voorheffingen,
                    ingehoudenDividendbelasting: this.dividendInBox2.value.box2Dividend,
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        }, 200)
    }
}
